import { render } from "./home-nearbyviewed.vue?vue&type=template&id=72ff0be0"
import script from "./home-nearbyviewed.js?vue&type=script&lang=js"
export * from "./home-nearbyviewed.js?vue&type=script&lang=js"

import "./home-nearbyviewed.vue?vue&type=style&index=0&id=72ff0be0&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__